import { render } from "./MonitoramentoTable.vue?vue&type=template&id=3106cb00&ts=true"
import script from "./MonitoramentoTable.vue?vue&type=script&lang=ts"
export * from "./MonitoramentoTable.vue?vue&type=script&lang=ts"

import "./MonitoramentoTable.vue?vue&type=style&index=0&id=3106cb00&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__